<template>
  <div class="iframe--wrapper" :style="lineStyle">
    <iframe v-if="linkUrl" :src="linkUrl" frameborder="0"></iframe>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .iframe--wrapper{
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    padding-top: 5px;
    overflow-y: hidden;
    &>iframe{
      width: 99%;
      height: 100%;
    }
  }
</style>
<script>
// import commonService from '@/assets/service/common'
// import {getCookie} from '@/assets/utils/CommonUtil'
import {mapState} from 'vuex'
export default {
  name: 'ApplicationIframe',
  data () {
    return {
      linkUrl: ''
    }
  },
  computed: {
    ...mapState({
      sessionAlertShow: state => state.config.sessionAlertShow
    }),
    lineStyle () {
      let sty = ''
      if (this.$route.query && this.$route.query.title && decodeURIComponent(this.$route.query.title) === '计价依据库') {
        sty += ' padding-top: 0;'
      }
      return sty
    }
  },
  created () {
    this.setLinkUrl()
  },
  methods: {
    // 1. 获取嵌入页面的URL地址
    setLinkUrl () {
      this.hideAllDialog(() => {
        let query = this.$route.query
        this.linkUrl = ''
        this.$nextTick(() => {
          console.log(query)
          if (query.linkUrl) {
            query = Object.assign(query, {
              name: query.menuName,
              appId: query.id,
              appModule: 3 // 在菜单表中 根据appId 找到linkUrl 判断跳转地址是否是白名单中数据
            })
            this.openLinkNewTab(query, (linkUrl) => {
              this.linkUrl = linkUrl
            })
            // const parameter = decodeURIComponent(query.linkParameter) || ''
            // const params = parameter.split(',')
            // if (params.includes('zjySsoLogin') || /(\?|&)(zjySsoLogin|singleLogin)=/.test(query.linkUrl)) {
            //   // 需要走造价云 单点登录 重定向到目标页面的方式(如: 计价依据库 的跳转)
            //   // 通过 参数里是否包含 'zjySsoLogin' 来判断的（无法，管理后台菜单已无可用字段，需重新考虑）
            //   const ZJYTOKEN = getCookie('ZJYTOKEN')
            //   const redirectUrl = commonService.zjySsoLogin() + '?weburl=' + encodeURIComponent(query.linkUrl) + '&token=' + ZJYTOKEN + '&gldDogNum=' + (getCookie('DOGNUM') || '')
            //   console.dir(redirectUrl)
            //   this.linkUrl = redirectUrl
            // } else {
            //   this.linkUrl = query.linkUrl
            // }
          }
        })
      })
    }
  },
  watch: {
    '$route.query': function () {
      this.setLinkUrl()
    },
    sessionAlertShow () {
      const parameter = decodeURIComponent(this.$route.query.linkParameter) || ''
      const params = parameter.split(',')
      if (params.includes('zjySsoLogin' || /(\?|&)(zjySsoLogin|singleLogin)=/.test(this.$route.query.linkUrl))) {
        this.linkUrl = ''
      }
    }
  }
}
</script>
